module.exports = __webpack_public_path__ + "assets/img/why.9c9aeae3.svg";